import https, { getApiConfig } from '../../utils/request'
import { RequestParams, ContentType, Method } from 'axios-mapper'
/** 平台-查看补货计划列表 */
export const GetPlanList = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/replenishment-list`, Method.GET, data, ContentType.form)
}
/** 平台-获取Maps配置 */
export const GetMapsList = () => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/maps`, Method.GET, {}, ContentType.form)
}
/** 平台-获取品类目录树 */
export const GetCategoryTree = () => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/category-tree`, Method.GET)
}
/** 平台-导出数据 */
export const ExportData = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/export`, Method.POST, data)
}
/** 平台-查看计划行日志 */
export const GetLogList = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/log-list`, Method.GET,data, ContentType.form)
}




/** 平台-删除补货计划 */
export const DeletePlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/delete-replenishment`, Method.POST, data)
}
/** 平台-创建补货计划 */
export const CreatePlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/save-replenishment`, Method.POST, data)
}
/** 平台-查看计划行明细 */
export const GetPlanDetail = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/replenishment-detail`, Method.POST, data)
}
/** 平台-查看计划t统计信息 */
export const GetSummaryCount = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/count`, Method.POST, data)
}
/** 平台-修改商品最小备货量 */
export const SetPackQty = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/set-pack-qty`, Method.POST, data)
}
/** 平台-设置调和比率 */
export const SetRate = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/set-rate`, Method.POST, data)
}
/** 平台-删除计划行 */
export const DeletePlanRow = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/delete-rows`, Method.POST, data)
}
/** 平台-submit备货计划 */
export const SubmitReplenishment = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/submit-replenishment`, Method.POST, data)
}
/** 平台-确定最终补货数量 */
export const SetRestockQty = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/restock-quantity`, Method.POST, data)
}
/** 平台-修改商品最小备货量 */
export const EditGoodsPackQty = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/set-pack-qty`, Method.POST, data)
}
/** 平台-关闭补货计划 */
export const ClosePlan = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/close-replenishment`, Method.POST, data)
}
/** 平台-补货计划行锁定 */
export const LockStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/lock-rows-status`, Method.POST, data)
}
/** 平台-补货计划行添加备注 */
export const AddRemark = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/remark`, Method.POST, data)
}
/** 平台-补货计划行审核 */
export const ChangeStatus = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/status`, Method.POST, data)
}
/** 平台-添加补货计划行 */
export const AddPlanRow = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.merchantUrl).request(`/apiadmin/v1/operation/${api_config.siteCode}/add-rows`, Method.POST, data)
}